import React from "react";
import styled from 'styled-components'
import Button from '@material-ui/core/Button'

const CancelButton = styled<any>(Button)`
	padding: 10px;
`;

export default CancelButton